<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        :color="statusColor(status)"
        size="20"
        v-bind="attrs"
        v-on="on"
      >
      </v-avatar>
    </template>
    <span>{{ statusLabel(status) }}</span>
  </v-tooltip>
</template>

<script>
import { getColor } from '@/utils'

export default {
  props: {
    status: {
      type: String,
      default: () => 'offline'
    }
  },

  methods: {
    statusColor (status) {
      try {
        return getColor(status)
      } catch {
        return getColor('unknown')
      }
    },
    
    statusLabel (status) {
      return status
    }
  }
}
</script>
